import React, { Component, Fragment } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import moment from "moment";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";

import Table from "../common/TableMultiCheckbox";
import TextField from "../common/TextField";
import Loader from "../../Layout/Loader";
import LoginAsUser from "../../Helpers/loginAsUser";

import {
  checkPrivileges,
  prepareUserForLogin,
  PaginationConfig,
} from "../../Helpers";
import CustomButton from "../common/Button";

const styles = (theme) => ({
  container: { display: "flex", flexWrap: "wrap" },
});

class UserAccessVehicle extends Component {
  constructor() {
    super();
    this.state = {
      usersReceived: false,
      selectedUnitsList: [],
      pagination: { ...PaginationConfig, pageSize: 20 },
      isChecked: false,
      isIndeterminate: false,
      allSelectedIds: [],
      noRecords: false,
      contractType: [],
      filteredUsersLength: 0,
      filteredUsers: [],
      loader: false,
      selectedSp: {},
      isUserLogin: false,
    };
  }

  componentDidMount() {
    this.getMoreUnits();
  }

  componentWillUnmount() {
    if (this.cancelToken) {
      this.cancelToken.cancel("Component unmounted");
    }
  }

  // ================= API =================
  getMoreUnits = async () => {
    const { pagination, contractType } = this.state;
    const { page, pageSize, itemSearch } = pagination;
    const { logInUser, aaCreated } = this.props;

    // const userType = aaCreated ? 4 : 3;

    let url = `/api/users/get?userId=${logInUser.id}&all=true&page=${page}&limit=${pageSize}&search=${itemSearch}`;
    let urlFiltered = `/api/users/get?userId=${logInUser.id}&all=true&limit=500&search=${itemSearch}`;
    let urlChecked = `/api/users/get?userId=${logInUser.id}&limit=1000`;

    const contractMap = {
      maintenance: 1,
      leasing: 2,
      cashcustomer: 3,
    };

    contractType.forEach((type) => {
      url += `&contractType=${contractMap[type]}`;
      urlFiltered += `&contractType=${contractMap[type]}`;
      urlChecked += `&contractType=${contractMap[type]}`;
    });

    if (this.cancelToken) this.cancelToken.cancel();
    this.cancelToken = axios.CancelToken.source();

    this.setState({ loader: true });

    try {
      const [mainRes, checkedRes, filteredRes] = await Promise.all([
        axios.get(url, { cancelToken: this.cancelToken.token }),
        axios.get(urlChecked, { cancelToken: this.cancelToken.token }),
        axios.get(urlFiltered, { cancelToken: this.cancelToken.token }),
      ]);

      const main = mainRes.data;
      if (main.status !== "success") return this.handleApiError(main);

      const users = main?.data?.data || [];

      if (!users.length) {
        return this.setState({
          selectedUnitsList: [],
          usersReceived: false,
          noRecords: true,
          loader: false,
        });
      }

      const selectedIds =
        checkedRes?.data?.data?.data?.map((u) => u.entityId) || [];

      const filteredUsers =
        filteredRes?.data?.data?.data?.map((u) => u.entity.id) || [];

      const filteredUsersLength = filteredRes?.data?.data?.data?.length || 0;

      const formattedUsers = users.map((item) => {
        return {
          ...item,
          entity: {
            ...item.entity,
            groupAccess: 0,
            check: selectedIds.includes(item.entity.id),
            contractNumber: item.extraInfo?.contractNumber,
            created: item.entity.created
              ? this.props.logInUser.twelveHourFormat
                ? moment(item.entity.created).format("YYYY-MM-DD hh:mm A")
                : moment(item.entity.created).format("YYYY-MM-DD HH:mm")
              : "",
          },
        };
      });

      let isChecked = false;

      if (contractType.length > 0) {
        isChecked = filteredUsers.length === filteredUsersLength;
      } else {
        isChecked =
          selectedIds.length === this.props.usersIds?.length &&
          this.props.usersIds?.length > 0;
      }
      this.setState({
        selectedUnitsList: prepareUserForLogin(formattedUsers),
        usersReceived: true,
        filteredUsers,
        filteredUsersLength,
        allSelectedIds: selectedIds,
        isChecked,
        pagination: {
          ...pagination,
          total: main.data.total,
          hasNext: main.hasNext,
        },
      });
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error(err);
        toast.error(this.props.translate("Error fetching users"));
      }
    } finally {
      this.setState({ loader: false });
    }
  };

  handleApiError = (res) => {
    if (res?.statusCode === "440") {
      window.location.replace("/login");
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  };

  // ================= EVENTS =================
  handleSearch = (value) => {
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, page: 1, itemSearch: value },
      }),
      this.getMoreUnits,
    );
  };

  handleChangePage = (page) => {
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, page },
      }),
      this.getMoreUnits,
    );
  };

  handleChangeRowsPerPage = (pageSize) => {
    this.setState(
      (prev) => ({
        pagination: { ...prev.pagination, pageSize },
      }),
      this.getMoreUnits,
    );
  };

  // ================= SELECT ALL =================
  selectAllUser = async (checked) => {
    try {
      const userIds = checked
        ? this.state.filteredUsers
        : this.state.allSelectedIds;

      const res = await fetch(`/api/permissions/multiproperty`, {
        method: checked ? "POST" : "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          vehicleId: this.props.newVehicleId,
          userIds,
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (data.status === "success" || data.status === "ambiguous") {
        this.setState({ isChecked: checked }, this.getMoreUnits);

        toast.success(
          this.props.translate(
            checked
              ? "userIsAssignedSuccessfully"
              : "userIsUnAssignedSuccessfully",
          ),
        );
      } else {
        throw new Error(data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Something went wrong");
    }
  };

  allUnitsId = (e) => {
    this.selectAllUser(e.target.checked);
  };

  // ================= SINGLE SELECT =================
  unitToUserpermission = async (checked, item) => {
    // optimistic UI
    this.setState((prev) => ({
      selectedUnitsList: prev.selectedUnitsList.map((u) =>
        u.entity.id === item.id
          ? { ...u, entity: { ...u.entity, check: checked } }
          : u,
      ),
    }));

    try {
      const res = await fetch(`/api/permissions`, {
        method: checked ? "POST" : "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: item.id,
          vehicleId: this.props.newVehicleId,
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      if (data.status === "success") {
        toast.success(
          this.props.translate(
            checked
              ? "userIsAssignedSuccessfully"
              : "userIsUnAssignedSuccessfully",
          ),
        );
      } else {
        throw new Error(data?.message);
      }
    } catch (error) {
      // rollback UI
      this.setState((prev) => ({
        selectedUnitsList: prev.selectedUnitsList.map((u) =>
          u.entity.id === item.id
            ? { ...u, entity: { ...u.entity, check: !checked } }
            : u,
        ),
      }));

      toast.error(error.message || "Something went wrong");
    }
  };

  // ================= LOGIN =================
  loginAsUser = (data) => {
    if (data[0].logInAsUserState) {
      this.setState({ userDataForLogin: data[0], isUserLogin: true });
    }
  };

  loginAsUserhandleChange = (id, value) => {
    this.setState((prev) => ({
      selectedUnitsList: prev.selectedUnitsList.map((item) =>
        item.entity.id === id ? { ...item, logInAsUserState: value } : item,
      ),
    }));
  };

  // ================= RENDER =================
  render() {
    const { usersReceived, loader, noRecords } = this.state;

    return (
      <Fragment>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          className="breadcrumb-row"
        >
          {/* Left: Title */}
          <Grid item xs={12} sm={4}>
            <h3 style={{ margin: 0 }}>
              {this.props.translate("userAccessVehicle")}
            </h3>
          </Grid>

          {/* Middle: Search */}
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              label={this.props.translate("search")}
              onChange={(e) => this.handleSearch(e.target.value)}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", sm: "flex-end" },
            }}
          >
            <CustomButton onClick={this.props.handleFinish}>
              {this.props.translate("finish")}
            </CustomButton>
          </Grid>
        </Grid>

        {loader ? (
          <Loader defaultStyle />
        ) : usersReceived ? (
          <Table
            rows={this.state.selectedUnitsList.map((i) => i.entity)}
            allUsersId={this.allUnitsId}
            selectItemParentId={this.props.newVehicleId}
            pagination={this.state.pagination}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            loginAsUser={this.loginAsUser}
            loginAsUserhandleChange={this.loginAsUserhandleChange}
            isChecked={this.state.isChecked}
            isIndeterminate={this.state.isIndeterminate}
            showCheckbox2
            userAccess={false}
            showGroupAccess
            notshowAllCheckbox
            checkHandleChange={this.unitToUserpermission}
            canAssign={checkPrivileges("userLinkDevice")}
            canRemove={checkPrivileges("userUnlinkDevice")}
            rowDefinition={[
              { id: "name", label: this.props.translate("sharedName") },
              { id: "email", label: this.props.translate("userEmail") },
              {
                id: "contractNumber",
                label: this.props.translate("contractNumber"),
              },
              // { id: "cityName", label: this.props.translate("city") },
              { id: "created", label: this.props.translate("createdAt") },
            ]}
          />
        ) : noRecords ? (
          <h4 style={{ textAlign: "center" }}>
            {this.props.translate("No Users Found")}
          </h4>
        ) : (
          <Loader defaultStyle />
        )}

        {this.state.isUserLogin && (
          <LoginAsUser selectedUser={this.state.userDataForLogin} />
        )}
      </Fragment>
    );
  }
}

export default compose(withStyles(styles), connect())(UserAccessVehicle);
